import { configureRequest } from "@asosteam/asos-web-request";
import { name, version } from "../../../appDetails";

export default () =>
  configureRequest({
    client: {
      name,
      version
    }
  });
